import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface Account {
  accountName: string;
  accountDisplay?: string;
}

export interface Props {
  children?: FC;
  item?: Account;
}

const AccountCell: FC<Props> = ({
  item = {
    accountName: '',
    accountDisplay: '',
  },
}) => {
  const { accountName, accountDisplay } = item;
  const displayValue = accountDisplay || accountName;
  return (
    <DataTableCell title={displayValue || ''}>
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {displayValue}
      </div>
    </DataTableCell>
  );
};

export default AccountCell;
